//these are static date
const deduction_types = [
    {deductionMode: 1, description: 'First cutoff'},
    {deductionMode: 2, description: 'Second cutoff'},
    {deductionMode: 3, description: 'Half per cutoff'},
    {deductionMode: 4, description: 'Monthly'},
]

export default {
    getDescription(deductionMode) {
        const description = deduction_types.filter(x => {
            return x.deductionMode == deductionMode
        })[0].description
        return description ? description : ''
    }
}